<template>
    <div class="row">
        <div class="col-sm-12" v-if="failedOrder.id">
            <h3>{{$t('components.administration.nav.failed-orders')}}</h3>
            <h4>{{$t('components.administration.failed-orders.concrete')}} #{{failedOrder.id}}</h4>
            <hr>
            <div class="row mt-3 mb-5">
                <div class="col-sm-12 col-md">
                    <button class="btn btn-wellis-gold text-white w-100"
                            :disabled="!resolveBtnRestart" @click="btnRestart">
                        {{$t('components.administration.failed-orders.btnRestart')}}
                    </button>
                </div>
                <div class="col-sm-12 col-md" v-if="resolveBtnSync">
                    <button class="btn btn-wellis-gold text-white w-100" @click="btnSync">
                        {{$t('components.administration.failed-orders.btnSync')}}
                    </button>
                </div>
                <div class="col-sm-12 col-md" v-if="resolveBtnNotification">
                    <button class="btn btn-wellis-gold text-white w-100" @click="btnNotifications">
                        {{$t('components.administration.failed-orders.btnNotifications')}}
                    </button>
                </div>
                <div class="col-sm-12 col-md">
                    <button class="btn btn-outline-wellis-black w-100"
                            :disabled="!resolveBtnCapture">
                        {{$t('components.administration.failed-orders.btnCaptureTransaction')}}
                    </button>
                </div>
                <div class="col-sm-12 col-md">
                    <button class="btn btn-outline-wellis-black w-100"
                            :disabled="!resolveBtnInvoice">
                        {{$t('components.administration.failed-orders.btnInvoice')}}
                    </button>
                </div>
                <div class="col-sm-12 col-md">
                    <button class="btn btn-danger w-100"
                            :disabled="!resolveBtnDelete" @click="btnDelete">
                        {{$t('components.administration.failed-orders.btnDelete')}}
                    </button>
                </div>
            </div>
            <hr>
            <div class="row mt-3">
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.failed-orders.orderNo')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.order_id" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.failed-orders.ifsOrderNo')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.ifs_order_no || '-'" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.failed-orders.phase')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.phase" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.category.status')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="$t('components.administration.failed-orders.status')[failedOrder.objstate]" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.failed-orders.createdAt')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.created_at | formatDate(true)" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.failed-orders.updatedAt')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.updated_at | formatDate(true)" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                        <label>{{$t('components.administration.failed-orders.lastJobId')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.last_job_uuid" readonly/>
                    </div>
                </div>
            </div>
            <h4>{{$t('components.administration.failed-orders.exception.title')}}</h4>
            <hr>
            <div class="row">
                <div class="col-sm-12 col-md-12">
                    <div class="row">
                        <div class="col-sm-12 col-md-3 font-weight-bold">
                            {{$t('components.administration.failed-orders.exception.type')}}:
                        </div>
                        <div class="col-sm-12 col-md-auto">
                            <i>{{failedOrder.exception.type}}</i>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-sm-12 col-md-3 font-weight-bold">
                            {{$t('components.administration.failed-orders.exception.message')}}:
                        </div>
                        <div class="col-sm-12 col-md-auto">
                            <i>{{failedOrder.exception.message}}</i>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-sm-12 col-md-3 font-weight-bold">
                            {{$t('components.administration.failed-orders.exception.code')}}:
                        </div>
                        <div class="col-sm-12 col-md-auto">
                            <i> {{failedOrder.exception.code}}</i>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-sm-12 col-md-3 font-weight-bold">
                            {{$t('components.administration.failed-orders.exception.file')}}:
                        </div>
                        <div class="col-sm-12 col-md-auto">
                            <i>{{failedOrder.exception.file}}</i>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-sm-12 col-md-3 font-weight-bold">
                            {{$t('components.administration.failed-orders.exception.line')}}:
                        </div>
                        <div class="col-sm-12 col-md-auto">
                            <i>{{failedOrder.exception.line}}.</i>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-sm-12 col-md-3 font-weight-bold">
                            {{$t('components.administration.failed-orders.exception.traceString')}}:
                        </div>
                        <div class="col-sm-12 col-md-9">
                            <textarea class="form-control form-control-sm" readonly rows="10" style="resize:vertical"
                                      :value="failedOrder.exception.traceString"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <h4 class="mt-3">{{$t('components.administration.failed-orders.request')}}</h4>
            <hr>
            <div class="row">
                <div class="col-sm-12">
                    <textarea class="form-control form-control-sm" readonly rows="10" style="resize:vertical"
                              :value="formatXml(failedOrder.request)"></textarea>
                </div>
            </div>
            <h4 class="mt-3">{{$t('components.administration.orders.concrete.title')}}</h4>
            <hr>
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <h5 class="mt-3">{{$t('components.administration.orders.concrete.order-head')}}</h5>
                </div>
                <div class="col-sm-12 col-md-6">
                    <button class="float-right btn btn-wellis-gold text-white col-md-1"
                            @click="update" :disabled="!changed">
                        <i class="fa fa-save"></i>
                    </button>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.customerNo')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.order.customer_no" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.billing.company')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.order.company" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.firstname')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.order.firstname" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.lastname')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.order.lastname" readonly/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.checkout.email')}} <small><i class="fa fa-pen"></i></small></label>
                        <input class="form-control form-control-sm" type="text" v-model="failedOrder.order.email"/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.soapIdentity')}} <small><i class="fa fa-pen"></i></small></label>
                        <input class="form-control form-control-sm" type="text" v-model="failedOrder.order.soap_identity"/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.custGroup')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.order.customer_group" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.currency')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.order.currency" readonly/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.orderAmountNet')}}</label>
                        <input class="form-control form-control-sm" type="text"
                               :value="failedOrder.order.order_amount_net | toPrice(failedOrder.order.currency, false)" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.orderAmount')}}</label>
                        <input class="form-control form-control-sm" type="text"
                               :value="failedOrder.order.order_amount_net | toPrice(failedOrder.order.currency, failedOrder.order.vat)" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.paymentMethod')}}</label>
                        <input class="form-control form-control-sm" type="text"
                               :value="$t('components.checkout.payments')[failedOrder.order.payment_method]" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.shippingMethod')}}</label>
                        <input class="form-control form-control-sm" type="text"
                               :value="$t('components.checkout.shippingMethods')[failedOrder.order.shipping_method]" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.billingAddressId')}} <small><i class="fa fa-pen"></i></small></label>
                        <input class="form-control form-control-sm" type="text" v-model="failedOrder.order.billing_address_id"/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.shippingAddressId')}} <small><i class="fa fa-pen"></i></small></label>
                        <input class="form-control form-control-sm" type="text" v-model="failedOrder.order.shipping_address_id"/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.tempShipping')}}</label>
                        <input class="form-control form-control-sm" type="text"
                               :value="$t('confirm')[failedOrder.order.temp_shipping ? 'yes': 'no']" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.tempShippingCountry')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.order.temp_shipping_country" readonly/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.tempShippingZip')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.order.temp_shipping_zip || '-'" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.tempShippingCity')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.order.temp_shipping_city || '-'" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.tempShippingAddress1')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.order.temp_shipping_address1 || '-'" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.tempShippingAddress2')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.order.temp_shipping_address2 || '-'" readonly/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.shippingServiceId')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.order.shipping_service_id || '-'" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>{{$t('components.administration.orders.concrete.lang')}}</label>
                        <input class="form-control form-control-sm" type="text" :value="failedOrder.order.lang || '-' | toUpper" readonly/>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <label>{{$t('components.checkout.notes')}} <small><i class="fa fa-pen"></i></small></label>
                    <textarea class="form-control form-control-sm" rows="5" style="resize:vertical"
                              v-model="failedOrder.order.note_text"></textarea>
                </div>
            </div>
            <h5 class="mt-3">{{$t('components.administration.orders.concrete.order-lines')}}</h5>
            <table class="table table-sm table-hover table-striped table-bordered">
                <thead>
                <th>Id</th>
                <th>{{$t('components.administration.orders.concrete.campaign') | capitalize}}</th>
                <th>{{$t('components.products.catalogNo') | capitalize}}</th>
                <th>{{$t('components.administration.orders.concrete.type') | capitalize}}</th>
                <th>{{$t('components.stocklist.name') | capitalize}}</th>
                <th>{{$t('components.products.quantity') | capitalize}}</th>
                <th>{{$t('components.products.discount') | capitalize}}</th>
                <th>{{$t('components.administration.orders.concrete.unitPrice') | capitalize}}</th>
                <th>{{$t('components.products.price') | capitalize}}</th>
                <th></th>
                </thead>
                <tbody>
                <tr v-for="orderItem in failedOrder.order.items" :key="orderItem.id" :class="orderItem.deleted_at !== null ? 'text-line-through' : ''">
                    <td>#{{orderItem.id}}</td>
                    <td>{{orderItem.campaign}}</td>
                    <td>{{orderItem.catalog_no}} {{orderItem.configuration !== '*' ? '*' : ''}}</td>
                    <td>{{orderItem.type}}</td>
                    <td>{{orderItem.name | cut(25)}}</td>
                    <td class="text-center">{{orderItem.quantity}}</td>
                    <td class="text-center">{{orderItem.discount > 0 ? orderItem.discount + '%' : '-'}}</td>
                    <td>{{(orderItem.unit_price_net / orderItem.quantity) | toPrice(failedOrder.order.currency, failedOrder.order.vat)}}</td>
                    <td>{{orderItem.unit_price_net | toPrice(failedOrder.order.currency, failedOrder.order.vat)}}</td>
                    <td class="text-center">
                        <b-button-group v-if="orderItem.deleted_at === null">
                            <b-button class="btn btn-wellis-white text-wellis-black btn-sm" @click="viewConfiguration(orderItem)" v-if="orderItem.configuration !== '*'">
                                <i class="fa fa-eye"></i>
                            </b-button>
                            <b-button class="btn btn-wellis-gold btn-sm text-white" @click="setEditorTarget(orderItem.id)"
                                      v-if="failedOrder.objstate === 'HANGING'">
                                <i class="fa fa-pen"></i>
                            </b-button>
                            <b-button class="btn btn-wellis-black btn-sm text-white" @click="removeOrderLine(orderItem.id)"
                                      v-if="failedOrder.objstate === 'HANGING'">
                                <i class="fa fa-trash"></i>
                            </b-button>
                        </b-button-group>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <FailedOrderItemEditorModal :target="resolveTarget" :visible="resolveModalVisibility"
                                    @close="editor.show = false"/>
    </div>
</template>

<script>
import OrdersApiService from "@/api/orders.api";
import FailedOrderItemEditorModal from "@/components/administration/orders/FailedOrderItemEditorModal";
import {__clone} from "@/helpers";

export default {
    name: "FailedOrder",
    components: {FailedOrderItemEditorModal},
    created() {
        this.fetch(this.$route.params.failedOrderId || 0);
    },

    data() {
        return {
            failedOrder: {},
            originalFailedOrder: {},
            editor: {
                show: false,
                target: null
            }
        }
    },

    methods: {
        fetch(failedOrderId) {
            return new Promise((resolve, reject) => {
                let loader = this.$loading.show();
                OrdersApiService.failed.concrete(failedOrderId)
                    .then(response => {
                        this.failedOrder = response.data;
                        this.originalFailedOrder = __clone(this.failedOrder);
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                        this.$swal.fire({
                            icon: "error",
                            allowOutsideClick: false,
                            html: this.$t('api-error')
                        }).then(() => {
                            this.$router.push({name: 'app.admin.orders.failed'});
                        });
                    })
                    .finally(() => {
                        loader.hide();
                        loader = null;
                    });
            });
        },

        setEditorTarget(target) {
            this.editor.target = target;
            this.editor.show = true;
        },

        viewConfiguration(item) {
            let body = '<table class="table table-bordered">'
                + '<tbody>';
            let configuration = JSON.parse(item.configuration);
            Object.values(configuration).forEach(line => {
                let value = line.values.find(x => line.selectedValue === x.optionValueId);
                if(value) {
                    value = value.description;
                }
                body += `<tr><td>${line.description}</td><td>${value || line.selectedValue}</td></tr>`;
            })
            this.$swal.fire({
                html: body + '</tbody></table>',
                width: "48em"
            });
        },

        formatXml(xml) {
            const PADDING = ' '.repeat(2);
            const reg = /(>)(<)(\/*)/g;
            let pad = 0;
            xml = xml.replace(reg, '$1\r\n$2$3');
            return xml.split('\r\n').map(node => {
                let indent = 0;
                if (node.match(/.+<\/\w[^>]*>$/)) {
                    indent = 0;
                } else if (node.match(/^<\/\w/) && pad > 0) {
                    pad -= 1;
                } else if (node.match(/^<\w[^>]*[^\\/]>.*$/)) {
                    indent = 1;
                } else {
                    indent = 0;
                }
                pad += indent;
                return PADDING.repeat(pad - indent) + node;
            }).join('\r\n');
        },

        resolveAttributes(object) {
            return {
                soapIdentity: object.order.soap_identity,
                email: object.order.email,
                noteText: object.order.note_text,
                shippingAddressId: object.order.shipping_address_id,
                billingAddressId: object.order.billing_address_id,
                items: object.order.items.map(item => {
                    return {
                        objId: item.id,
                        uniqueId: item.unique_id,
                        itemData: item.item_data,
                        configuration: item.configuration
                    }
                })
            }
        },

        update() {
            let loader = this.$loading.show();
            OrdersApiService.failed.update(this.failedOrder.order.id, this.resolveAttributes(this.failedOrder))
                .then(() => this.originalFailedOrder = __clone(this.failedOrder))
                .catch(() => {
                    this.$swal.fire({
                        icon: "error",
                        allowOutsideClick: false,
                        html: this.$t('whoops')
                    });
                })
                .finally(() => {
                    loader.hide();
                    loader = null;
                });
        },

        removeOrderLine(orderLineId) {

            this.$swal.fire({
                icon: "question",
                title: this.$t('confirm.title'),
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonText: this.$t('confirm.yes'),
                cancelButtonText: this.$t('confirm.cancel'),
            }).then(result => {
                if (result.value) {
                    let loader = this.$loading.show();
                    OrdersApiService.failed.removeOrderLine(this.failedOrder.order.id, orderLineId)
                        .then(async () => await this.fetch(this.failedOrder.id))
                        .catch(() => {
                            this.$swal.fire({
                                icon: "error",
                                allowOutsideClick: false,
                                html: this.$t('whoops')
                            });
                        })
                        .finally(() => {
                            loader.hide();
                            loader = null;
                        });
                }
            });
        },

        btnRestart() {
            let loader = this.$loading.show();
            OrdersApiService.failed.restart(this.failedOrder.id)
                .then(() => {
                    this.$swal.fire({
                        icon: "success",
                        html: this.$t('components.administration.failed-orders.resend-success')
                    });
                })
                .catch(error => {
                    this.$swal.fire({
                        icon: "error",
                        allowOutsideClick: false,
                        html: [this.$t('whoops'), '', error.response.data.message].join('<br>')
                    });
                })
                .finally(async () => {
                    loader.hide();
                    loader = null;
                    await this.fetch(this.failedOrder.id);
                });
        },

        btnNotifications() {
            let loader = this.$loading.show();
            OrdersApiService.failed.notifications(this.failedOrder.id)
                .then(() => {
                    this.$swal.fire({
                        icon: "success",
                        html: this.$t('components.administration.failed-orders.notification-success')
                    });
                })
                .catch(error => {
                    this.$swal.fire({
                        icon: "error",
                        allowOutsideClick: false,
                        html: [this.$t('whoops'), '', error.response.data.message].join('<br>')
                    });
                })
                .finally(async () => {
                    loader.hide();
                    loader = null;
                    await this.fetch(this.failedOrder.id);
                });
        },

        btnDelete() {
            let loader = this.$loading.show();
            OrdersApiService.failed.inactivate(this.failedOrder.id)
                .then(() => {
                    this.$swal.fire({
                        icon: "success",
                        html: this.$t('components.administration.failed-orders.inactivation-success')
                    });
                })
                .catch(error => {
                    this.$swal.fire({
                        icon: "error",
                        allowOutsideClick: false,
                        html: [this.$t('whoops'), '', error.response.data.message].join('<br>')
                    });
                })
                .finally(async () => {
                    loader.hide();
                    loader = null;
                    await this.fetch(this.failedOrder.id);
                });
        },

        btnSync() {
            let loader = this.$loading.show();
            OrdersApiService.failed.sync(this.failedOrder.id)
                .then(() => {
                    this.$swal.fire({
                        icon: "success",
                        html: this.$t('components.administration.failed-orders.sync-success')
                    });
                })
                .catch(error => {
                    this.$swal.fire({
                        icon: "error",
                        allowOutsideClick: false,
                        html: [this.$t('whoops'), '', error.response.data.message].join('<br>')
                    });
                })
                .finally(async () => {
                    loader.hide();
                    loader = null;
                    await this.fetch(this.failedOrder.id);
                });
        },
    },

    computed: {
        resolveTarget() {
            if (!this.editor.target) {
                return {};
            }
            return this.failedOrder.order.items.find(x => x.id === this.editor.target);
        },

        resolveModalVisibility() {
            return this.editor.show;
        },

        changed() {
            return this.failedOrder.objstate === 'HANGING' &&
                JSON.stringify(this.resolveAttributes(this.failedOrder)) !== JSON.stringify(this.resolveAttributes(this.originalFailedOrder));
        },

        resolveBtnRestart() {
            return (this.failedOrder.phase.startsWith('[1.0]')
                || this.failedOrder.phase.startsWith('[2.0]'))
                && !this.failedOrder.order.ifs_order_no;
        },

        resolveBtnCapture() {
            return this.failedOrder.phase.startsWith('[3.2]')
                && this.failedOrder.order.ifs_order_no;
        },

        resolveBtnInvoice() {
            return this.failedOrder.phase.startsWith('[3.3]')
                && this.failedOrder.order.ifs_order_no;
        },


        resolveBtnDelete() {
            return this.failedOrder.objstate === 'HANGING';
        },

        resolveBtnNotification() {
            return this.failedOrder.order.ifs_order_no && this.failedOrder.objstate === 'RESOLVED';
        },

        resolveBtnSync() {
            return this.failedOrder.order.ifs_order_no && this.failedOrder.phase.startsWith('[3.1]');
        }
    },

    watch: {
        "editor.show": function () {
            if (this.editor.show) {
                document.body.classList.add('overflow-hidden');
            } else {
                document.body.classList.remove('overflow-hidden');
            }
        }
    }
}
</script>

<style scoped>

</style>
